import { selector, selectorFamily, useRecoilValue } from 'recoil';
import { DisputeEventTypes } from 'enums';
import { DisputeService } from 'services';
import { isAuthenticated, refreshState } from 'state';
import { ResolutionReason } from 'types';

export const allResolutionReasons = selector<ResolutionReason[]>({
    key: 'allResolutionReasons',
    get: async ({ get }) => {
        get(refreshState('allResolutionReasons'));
        if (get(isAuthenticated)) {
            const service = new DisputeService();
            return await service.getResolutionReasons();
        }
        return [];
    }
});

export const resolutionReasons = selectorFamily<ResolutionReason[], DisputeEventTypes>({
    key: 'resolutionReasons',
    get: (type) =>
        ({ get }) => {
            const allReasons = get(allResolutionReasons);
            return allReasons.filter(({ eventType }) => eventType === type);
        }
});

export const useAllResolutionReasons = () => useRecoilValue(allResolutionReasons);
export const useResolutionReasons = (type: DisputeEventTypes) => useRecoilValue(resolutionReasons(type));